const CheckIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_1681_1317" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
            <rect width="48" height="48" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_1681_1317)">
            <path d="M21.819 30.0729L32.5075 19.4039L30.927 17.8344L21.931 26.8309L17.073 21.9729L15.4115 23.6344L21.819 30.0729ZM24 42.9304C19.654 41.7381 16.0675 39.1516 13.2405 35.1709C10.4135 31.1902 9 26.7819 9 21.9459V10.6614L24 5.0459L39 10.6614V21.9459C39 26.7819 37.5865 31.1902 34.7595 35.1709C31.9325 39.1516 28.346 41.7381 24 42.9304ZM24 40.5614C27.7307 39.3461 30.7852 37.0089 33.1635 33.5499C35.5415 30.0909 36.7305 26.2229 36.7305 21.9459V12.2424L24 7.4574L11.2695 12.2424V21.9459C11.2695 26.2229 12.4585 30.0909 14.8365 33.5499C17.2148 37.0089 20.2693 39.3461 24 40.5614Z" fill="currentColor" />
        </g>
    </svg>

);

export default CheckIcon;
